<template>
    <div>
        <ul class="box">
            <li v-for="(item,index) in user" :key="index">
                <label v-if="item.cfgType=='T'">
                    <span class="label"><span style="color:red" v-show="item.cfgNeedFl=='1'">*</span>{{item.cfgName}}</span>
                    <input class="input" type="text" v-model="item.cfgValue" :placeholder="item.cfgName">
                    <p v-show="user_copy[index]===1&&dirty" class="err-msg">{{item.cfgHint}}</p>
                </label>
                <label v-if="item.cfgType=='DDL'">
                    <span class="label"><span style="color:red" v-show="item.cfgNeedFl=='1'">*</span>{{item.cfgName}}</span>
                    <!-- <input class="input" type="text" v-model="item.cfgValue" :placeholder="item.cfgName"> -->
                    <select v-model="item.cfgValue" class="select">
                        <option v-for="opt in item.cfgContent.split('|')" :value="opt">{{opt}}</option>
                    </select>
                    <p v-show="user_copy[index]===1&&dirty" class="err-msg">{{item.cfgHint}}</p>
                </label>
            </li>
        </ul>
        <div class="next-btn-box">
            <button class="next-btn" @click="next">{{ $t("btn.next") }}</button>
        </div>
    </div>
</template>
<script>
export default {
    data() {
            return {
                dirty: false,
                user: [],
                next_btn_active: false,
                opFlag: '',
                info: {},
            }
        },
        props: {},
        methods: {
            next() {
                this.dirty = true;
                let num = 0;
                this.user_copy.map((item, index) => {
                    if (item !== 0) {
                        num++;
                    }
                });
                if (num !== 0) {
                    return;
                } else {

                    this.setStorage();
                    this.next_btn_active = true;

                    if (this.opFlag == '1') {
                        this.modInfo();
                    } else {
                        this.$router.push('/sign/apply/0');
                    }
                }
            },
            modInfo() {
                let params = {
                    regid: this.info.register.regId,
                    uid: this.info.register.regUid, //用户id
                    cid: this.info.register.regCid, //会议id
                    // reg_status: '1', // 1:报名提交
                    src: '2', //来源 1:WECHAT 2:WEB 3:ANDROID 4:IOS 5:后台管理
                };
                let configObj = this.info.user_config.map((item, i) => {
                    params[item.cfgCode] = item.cfgValue
                });
              params.cfgid = localStorage.getItem('sourceId')||'';
                this.postHttp('/medapp/api/template/register/add', params).then((result) => {
                    if (result.data.code === '0') {
                        this.$router.push('/order/info');
                    }
                })
            },
            setStorage() {
                this.info.user_config = this.user;
                sessionStorage.setItem('info', JSON.stringify(this.info));
            }
        },
        computed: {
            user_copy() {
                let user = this.user.map((item, index) => {
                    if (item.cfgRegex == null || item.cfgRegex == '') return 0;
                    let reg = new RegExp(item.cfgRegex);
                    if (item.cfgValue == null) {
                        return item.err = 1;
                    }
                    if (reg.test(item.cfgValue)) {
                        return item.err = 0;
                    } else {
                        return item.err = 1;
                    }
                });
                return user;
            },
        },
        mounted() {
            this.opFlag = this.$route.params.opFlag;
            let userStore = JSON.parse(localStorage.getItem('user'));
            if (userStore === undefined || userStore === null) {

                if(localStorage.locale =='en'){
                  this.$Message.warning('Please log in!', 3);
                    this.$router.push('/home_en/2006/detail/login');
                }else{
                  this.$Message.warning('请登录!', 3);

                  this.$router.push('/home/2006/detail/login_cn');
                }
                return;
            }
            let uid = userStore.uId;
            let cid = Number(localStorage.getItem('cid').trim());
            this.postHttp('/medapp/api/template/register/info', {
                uid: uid,
                cid: cid
            }).then((result) => {
                let data = '';
                //          如果用户已经报名，跳转到报名信息页面
                if (result.data.register != null && (result.data.register.regFl == '1' || result.data.register.regFl == '2') && this.opFlag != '1') {
                    this.$router.push('/order/info');
                    return;
                }
                if (result.data.hotel_book != null) {
                    for (let i = 0; i < result.data.hotel_book.length; i++) {
                        if ((result.data.hotel_book[i].bookFl == '1' || result.data.hotel_book[i].bookFl == '2') && this.opFlag != '1') {
                            this.$router.push('/order/info');
                            return;
                        }
                    }
                }


                if (sessionStorage.getItem('info') && JSON.parse(sessionStorage.getItem('info')).register != null && JSON.parse(sessionStorage.getItem('info')).register.regUid == uid) {
                    data = JSON.parse(sessionStorage.getItem('info'));
                    //              console.log(data);
                    //        原始数据
                    this.info = data;
                    //        user
                    this.user = data.user_config;
                } else {
                    //            console.log(result);
                    //        原始数据
                    this.info = result.data;
                    //        user
                    this.user = result.data.user_config;
                    //        给每个字段添加一个err属性
                    this.user.map((item, index) => {
                        return item.err = 0;
                    });
                    this.setStorage();
                }

            })
        }
}
</script>
<style scoped>
@keyframes bounce2 {
    0% {
        transform: scale(.8, .8);
    }
    30% {
        transform: scale(1.4, 1.4);
    }
    70% {
        transform: scale(.8, .8);
    }
    100% {
        transform: scale(1, 1);
    }
}

.bounce2 {
    animation: bounce2 ease-in .3s;
}

.box {
    width: 480px;
    margin: 73px auto 0;
    font-size: 14px;
    color: #000000;
}

.box li {
    margin-top: 20px;
    position: relative;
    font-size: 16px;
}

li label {
    display: block;
}

.label {
    display: inline-block;
    width: 140px;
}

.input {
    line-height: 30px;
    padding: 5px;
    padding-left: 20px;
    margin-left: 20px;
    width: 300px;
    border-radius: 30px;
    border: 1px solid #DCDCDC;
}

.select {
    line-height: 30px;
    padding: 5px;
    padding-left: 20px;
    margin-left: 20px;
    width: 300px;
    border-radius: 30px;
    border: 1px solid #DCDCDC;
}

.err-msg {
    color: red;
    font-size: 12px;
    position: absolute;
    left: 200px;
}

.next-btn-box {
    text-align: center;
    margin: 100px auto 30px;
}

.next-btn {
    border-radius: 30px;
    width: 300px;
    border: 0;
    padding: 0;
    line-height: 40px;
    background-color: #33D0C2;
    color: #FFFFFF;
    font-size: 15px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// addInfo.vue?191d144e